<template>
  <div class="rest-form-item">
    <div class="rest-form-custom-upload">
      <div class="upload-content">
        <upload
          ref="uploadm"
          v-model="fileList"
          :config="config"
          :readonly="readonly"
          @change="handleSuccess"
          @remove="removeFile"
        ></upload>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Cookie,
  Storage
} from '@/utils/utils';
import upload from './upload'
import projectConfig from '@config/projectConfig'
export default {
  name: "Attachment",
  props: ['value', 'config', 'readonly', 'defaultValue'],
  components: {
    upload
  },
  data() {
    return {
      fileList: [],
      uploadingList: [],
      sorrt: false,
      rojectConfig: projectConfig,
      fileIcon: [
        {
          icon: '/image/icon/icon_mp4_annex.png',
          list: 'mp4,avi,flv,wav,mov,mpeg,dat,mpg'
        },
        {
          icon: 'image/icon/icon_doc_annex.png',
          list: 'doc,docx,text'
        }, {
          icon: 'image/icon/icon_gif_annex.png',
          list: 'gif'
        }, {
          icon: 'image/icon/icon_jpg_annex.png',
          list: 'jpg,jpeg,png,bmp,svg'
        }, {
          icon: 'image/icon/icon_xls_annex.png',
          list: 'xls,xlsx'
        }, {
          icon: 'image/icon/icon_ppt_annex.png',
          list: 'ppt,pptx'
        }, {
          icon: 'image/icon/icon_pdf_annex.png',
          list: 'pdf'
        }
      ]
    }
  },
  watch: {
    fileList() {
      this.$emit('input', this.fileList)
    }
  },
  computed: {
    headers() {
      return { 'X-TOKEN': Storage.get('wfUserInfo').token }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.fileList = this.defaultValue
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val.map(res => res.attachment.attachment_sign)
      }
    },
    getIconType(type) {
      let item = this.fileIcon.find(res => res.list.indexOf(type) > -1)
      return item ? item.icon : 'image/icon/icon_doc_annex.png'
    },
    handleSuccess({ file }) {
      // let idx = 0
      // this.uploadingList.find((res, index) => {
      //   if (res.attachment_name === file.attachment_name) {
      //     idx = index
      //     return true
      //   }
      // })
      // this.uploadingList.splice(idx, 1)
      this.fileList.push({
        attachment_name: file.attachment_name,
        attachment_link: file.attachment_link,
        attachment_sign: file.attachment_sign,
        attachment_type: file.attachment_type,
        attachment_size: file.attachment_size,
        oss_attachment_name: file.oss_attachment_name,
        id: file.id
      })
      this.$nextTick(() => {
        this.$emit('change', this.fileList.map(res => res.attachment_sign), this.fileList)
      })
    },
    removeFile(index) {
      this.fileList.splice(index, 1)
      this.$nextTick(() => {
        this.$emit('change', this.fileList.map(res => res.attachment_sign), this.fileList)
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.file-list-drop {
  margin-top: 8px !important;
  max-height: 400px;
  overflow-x: hidden;
}
.attachment-label {
  width: 100%;
  display: flex;
  justify-content: space-between;
  i {
    font-size: 12px;
    margin-right: 6px;
  }
  .attachment-label-right {
    .icon {
      visibility: hidden;
    }
    .iconicon_arrow_task {
      transform: rotateZ(0);
      transition: all 0.3s;
      // margin-right: 8px;
    }
    .active {
      transform: rotateZ(180deg);
    }
    i {
      cursor: pointer;
      &:hover {
        color: $colorStatus-activeColor;
      }
    }
  }
  &:hover {
    .attachment-label-right .icon {
      visibility: visible;
    }
  }
}
.attachment-item-dom {
  position: relative;
  cursor: pointer;
  display: flex;
  height: 32px;
  border-bottom: 1px solid #edeef2;
  padding: 5px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  padding-right: 18px;
  margin-bottom: 6px;
  font-size: 14px;
  min-width: 65px;
  max-width: 185px;
  &:hover {
    background-color: #f3f4f5;
    .el-icon-download {
      visibility: visible;
    }
  }
  > div {
    display: flex;
    align-items: center;
  }
}
.attachment-item-dom span {
  display: block;
  max-width: 280px;
  font-size: 14px;
  @include ellipsis;
}
.attachment-item-dom > i {
  font-size: 12px;
  color: #444;
  padding: 6px;
}
.attachment-item-dom .el-icon-download {
  visibility: hidden;
}
.attachment-item-dom .iconicon_close_toast {
  margin-left: 8px;
  font-size: 16px;
  cursor: pointer;
}
.rest-form-custom-upload {
  width: 100%;
  display: flex;
  padding: 0 0px;
  margin-bottom: 0px;
  align-content: center;
  align-items: flex-start;
  // align-items: center;
  .more {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    &:hover {
      background-color: rgba(32, 32, 32, 0.08);
      i {
        color: $color-active;
      }
    }
  }
  .upload-content {
    display: flex;
    align-content: center;
    align-items: flex-start;
    width: 100%;
  }
  .my-upload-list {
    transition: all 0.3s;
    max-height: 1000px;
  }
  .custom-upload-rest {
    .my-upload-list {
      max-height: 156px;
      overflow: hidden;
    }
  }
  .only-value {
    display: flex;
    align-items: center;
    width: 100%;
    .attachment-item {
      margin-bottom: 0;
    }
  }
  .item-tops {
    display: flex;
    padding-top: 0px;
    i {
      width: 20px;
      height: 20px;
      cursor: pointer;
      &:hover {
        color: #509aff;
      }
    }
  }
  .iconicon_annex1 {
    margin-top: 2px;
    color: #75748e;
  }
  &:hover {
    .iconicon_annex {
      color: #509aff;
    }
  }
  .attachment-list-box {
    display: flex;
    align-items: center;
    padding: 0 10px;
    padding-right: 14px;
    flex-wrap: wrap;
    max-height: 35px;
    max-width: 298px;
    overflow: hidden;
  }
  .attachment-list-box-rest {
    overflow: auto;
    overflow-x: hidden;
    max-height: 200px;
  }
  .attachment-list {
    flex: 1;
    align-items: center;
  }
  .attachment-item {
    position: relative;
    cursor: pointer;
    display: flex;
    height: 32px;
    border: 1px solid #edeef2;
    padding: 5px 8px;
    box-sizing: border-box;
    border-radius: 4px;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    // margin-right: 10px;
    margin-bottom: 6px;
    font-size: 14px;
    min-width: 65px;
    max-width: 185px;
    background-color: #fff;
    > div {
      display: flex;
      align-items: center;
    }
  }
  .el-dropdown {
    padding: 0 6px;
    cursor: pointer;
  }
  .attachment-item span {
    display: block;
    max-width: 280px;
    @include ellipsis;
  }
  .attachment-item > i {
    font-size: 12px;
    color: #c9cdd9;
    padding: 6px;
  }
  .attachment-item .iconicon_close_toast {
    margin-left: 8px;
    font-size: 16px;
    cursor: pointer;
  }
  .attachment-item:hover {
  }
  .downing-bix {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #fff;
    padding: 0 10px;
    font-size: 12px;
    span {
      margin-left: 4px;
    }
  }
  .upload {
    /* width: 32px; */
    // height: 32px;
    // line-height: 32px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    span {
      margin-left: 9px;
    }
    &:hover {
      color: #509aff;
    }
  }
  .upload-demo {
    display: block;
    padding-left: 8px;
    .iconicon_enlarge {
      margin-right: 20px;
    }
  }
  .upload > span {
    vertical-align: -2px;
  }
  .attachment-item-uploading {
    width: 100%;
    font-size: 12px;
    justify-content: flex-start;
    position: relative;
    .uploading-progress {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0.4;
      .el-progress-bar,
      .el-progress-bar__outer,
      .el-progress-bar__inner {
        height: 100% !important;
        border-radius: 0;
      }
      .el-progress-bar__inner {
        background-color: #00b97e;
      }
    }
    span {
      margin-left: 4px;
    }
    i {
      font-size: 16px;
    }
  }
  .img-item {
    display: flex;
    align-items: center;
    // @include ellipsis;
  }
}
.custom-upload-only-value {
  padding-left: 8px;
}
</style>
